import React from 'react';

import { times } from 'lodash';

import ContentLoaderChatMessage from './ContentLoaderChatMessage';
import ContentLoaderPatientHeader from './ContentLoaderPatientHeader';

export interface ContentLoaderChatProps {}

const ContentLoaderChat: React.FC<ContentLoaderChatProps> = () => (
  <React.Fragment>
    <ContentLoaderPatientHeader />
    {times(10, (i) => (
      <ContentLoaderChatMessage toRight={i % 2 === 0} key={i} />
    ))}
  </React.Fragment>
);

export default ContentLoaderChat;
